// extracted by mini-css-extract-plugin
export default {"container":"styles_container__67gV6","notification":"styles_notification__9G4te","primaryButton":"styles_primaryButton__Bj7li"};